$(window).resize(function() {
    if ($(window).width() >= 992) {
        /*  wenn in der mobilen Ansicht der "Bestellung"-Tab aktiv ist und man wechselt auf die Desktop Variante, müssen die Kataloge wieder angezeigt werden */
        $(".ttgWanderkartenTabContent").show();
        $('#ttgKatalogForm').hide();
        $(".ttgWanderkarten").show();
        $('.ttgKatalogeCategoryHeadline').show();
        $('.ttgKatalogSocialShare').show();
        $('.ttgKatalogeInfoPopUp').hide();
    }

    if ($(window).width() < 992) {

        if ($(".ttgTabBestellungBtn").hasClass("ttgTabActive")) {
            $(".ttgWanderkarten").show();
            $(".ttgWanderkartenTabContent").hide();
            $('#ttgKatalogForm').show();
            $('.ttgKatalogeCategoryHeadline').hide();
            $('.ttgKatalogSocialShare').hide();
        }
    }
});

//Kataloge
if ($("#ttgKatalogForm .google-recaptcha").length) {
    $('#ttgKatalogForm .recaptcha-consent input[type="checkbox"]').on('change', function() {
        if ($(this).is(':checked')) {
            var sitekey = $("#ttgKatalogForm").find('.google-recaptcha').data('sitekey');
            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://www.google.com/recaptcha/api.js?onload=onloadCallbackKatalog&render=' + sitekey;
            script.setAttribute('defer', '');
            head.appendChild(script);
        }
    });
}

var onloadCallbackKatalog = function() {
    grecaptcha.ready(function() {
        grecaptcha.execute($("#ttgKatalogForm").find('.google-recaptcha').data('sitekey'), {
            action: 'submitKatalog'
        }).then(function(token) {
            $('#ttgKatalogForm input[type="hidden"][name="g-recaptcha-response"]').val(token);
        });
    });
};

/* PARSLEY */
$('#ttgKatalogForm').parsley();

/*  Tabs */
$('.ttgTabKatalogeBtn').click(function() {
    $('#ttgKatalogForm').hide();
    $('.ttgWanderkartenTabContent').show();
    $('.ttgKatalogeCategoryHeadline').show();
    $('.ttgKatalogSocialShare').show();
});

$('.ttgTabBestellungBtn').click(function() {
    $('.ttgWanderkartenTabContent').hide();
    $('#ttgKatalogForm').show();
    $('.ttgKatalogeCategoryHeadline').hide();
    $('.ttgKatalogSocialShare').hide();
});


$('.ttgCheckCat').parent().hide();
$('.ttgCheckCat').click();

if ($('#checked' + $('.ttgCheckCat').attr('id')).length) {
    /*  wenn vorhanden, entferne ihn */
    $('#checked' + $('.ttgCheckCat').attr('id')).parent().parent().parent().remove();
} else {
    /*  wenn nicht vorhanden, füge ihn hinzu			 */
    $('<div class="checkedCat" data-catTitle="' + $('.ttgCheckCat').attr('data-catTitle') + '" data-catID="' + $('.ttgCheckCat').attr('data-catID') + '"><div class="row"><div class="col-md-12 col-sm-12 col-xs-12">' + $('.ttgCheckCat').attr('data-catTitle') + ' [' + $('.ttgCheckCat').attr('data-catPreis') + '] <a href="javascript:removeCat(\'' + $('.ttgCheckCat').attr('id') + '\');" class="ttgCheckCat checked" id="checked' + $('.ttgCheckCat').attr('id') + '"></a></div></div></div>').appendTo('div#catHolder' + $('.ttgCheckCat').attr('data-catPos'));
    $('h3.invalid').removeClass('invalid');
}

/*  Tabs */
$(window).resize(function() {
    var bildschirmbreite1 = $(window).width();
    if (bildschirmbreite1 <= 970) {
        if ($('.ttgTabKatalogeBtn').hasClass('ttgTabActive') == true) {
            $('.ttgCatalogues').show();
            $('#ttgKatalogForm').hide();
        }
        if ($('.ttgTabBestellungBtn').hasClass('ttgTabActive') == true) {
            $('#ttgKatalogForm').show();
            $('.ttgCatalogues').hide();
        }
    } else {
        $('#ttgKatalogForm').show();
        $('.ttgCatalogues').show();
    }
});

$('.ttgTabKatalogeBtn').click(function() {
    $('#ttgKatalogForm').hide();
    $('.ttgCatalogues').show();
    $('.ttgKatalogSocialShare').show();
});

$('.ttgTabBestellungBtn').click(function() {
    $('.ttgCatalogues').hide();
    $('#ttgKatalogForm').show();
    $('.ttgKatalogSocialShare').hide();
});


/*  added 28.7.2014 - melaande - Ticket 3513 */
var hash = window.location.hash.substring(1);
if (hash) {
    $('.ttgColLeft').find('.ttgKatalogeCategoryHeadline a[data-hash=' + hash + ']').parent().next('ul').toggleClass('closed');
    $('.ttgColLeft').find('.ttgKatalogeCategoryHeadline a[data-hash=' + hash + ']').toggleClass('closed');
}

$('.ttgCheckCat').bind('click', function() {
    /*  $(this).toggleClass('checked'); */
    var bildschirmbreite = $(window).width();
    if (bildschirmbreite <= 991) {
        $('.ttgTabBestellungBtn').click();
    }
});

/*  Check Field direkt nach Eingabe */
$('#ttgKatalogForm .required').blur(function() {
    checkField($(this).attr('id'));
});

/*  Check Form bei Submit */
$('#ttgKatalogForm').on('click', '.ttgKatalogSubmitButton', function(e) {

    /*  Check Fields */
    $('#ttgKatalogForm .required').each(function(i) {
        checkField($(this).attr('id'));
    });

    /*  Check Kataloge */
    if ($('#ttgKatalogForm').find('.checkedCat').length) {
        $('h3.ttgAuswahl').removeClass('invalid');
    } else {
        $('h3.ttgAuswahl').addClass('invalid');
    }

    /*  Check ob Klasse invalid vorhanden >> ERROR */
    if ($('#ttgKatalogForm').find('.invalid').length) {

        /*  FEHLER IM FORMULAR */
        return false;

    } else {

        /*  FORMULAR KORREKT */
        e.preventDefault();

        /*  Befülle das Hidden-Field #kataloge mit den Werten */
        var kataloge = "";
        $('#ttgKatalogForm').find('.checkedCat').each(function(i) {
            kataloge = kataloge + $(this).attr('data-catTitle');
        });
        $('#ttgKatalogForm #kataloge').val(kataloge);

        /*  Leere noch vorhandene Standardwerte */
        $('#ttgKatalogForm input').each(function(i) {
            if ($(this).val() == $(this).attr('title')) {
                $(this).val('');
            }
        });

        /* den Button auf disabled setzen um 2x abzuschicken zu verhindern */
        setTimeout(() => {
            $('button.ttgWanderkarteBestellenButton').attr('disabled', 'disabled');
        }, 50);

        /*  Formular absenden – vorher frisches reCAPTCHA-Token holen, da v3-Tokens nur 2 Minuten gültig sind
            und das Token vom Consent-Klick beim Absenden oft schon abgelaufen ist (timeout-or-duplicate) */
        if (window.grecaptcha && $("#ttgKatalogForm .google-recaptcha").length) {
            grecaptcha.execute($("#ttgKatalogForm").find('.google-recaptcha').data('sitekey'), {
                action: 'submitKatalog'
            }).then(function(token) {
                $('#ttgKatalogForm input[type="hidden"][name="g-recaptcha-response"]').val(token);
                $('#ttgKatalogForm').submit();
            }).catch(function() {
                /*  Fallback: mit altem Token absenden statt Formular hängen zu lassen */
                $('#ttgKatalogForm').submit();
            });
        } else {
            $('#ttgKatalogForm').submit();
        }
    }

});

/*  leere Eingabefeld wenn Standartwert */
$('#ttgKatalogForm input, #ttgKatalogForm textarea').focus(function() {
    if ($(this).val() == $(this).attr('title')) {
        $(this).val('');
    }
});

/*  fülle Eingabefeld mit Standartwert wenn keine Eingabe */
$('#ttgKatalogForm input, #ttgKatalogForm textarea').blur(function() {
    if (!$(this).val()) {
        $(this).val($(this).attr('title'));
    }
});

$('.ttgKatalogeCategoryHeadline a').click(function() {

    /*  added 28.7.2014 - melaande - Ticket 3513		 */
    var hash = $(this).data('hash');
    location.hash = hash;

    $(this).parent().next('ul').toggleClass('closed');
    $(this).toggleClass('closed');
});


/*  Check Fields */
function checkField(id) {

    var value = $('#' + id).val(); /*  aktueller Wert */
    var title = $('#' + id).attr('title'); /*  Standartwert */

    /*  Check ob Standartwert oder leer >> ERROR */
    if ((value == title) || !value) {

        $('#' + id).addClass('invalid');

    } else {

        /*  Spezieller Check für eMail Feld */
        if (id == "email") {
            /*  Check auf korrekte eMail-Adresse */
            var reg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            if (reg.test(value)) {
                $('#' + id).removeClass('invalid'); /*  eMail-Adresse korrekt */
            } else {
                $('#' + id).addClass('invalid'); /*  eMail-Adresse unkorrekt >> ERROR */
            };

        } else {

            $('#' + id).removeClass('invalid');
            if ($('#' + id).attr('id') == "anrede" || $('#' + id).attr('id') == "land") {
                $('#' + id).next().removeClass('invalid');
            }

        }

    }

}

/*  entferne gewählten Katalog */
function removeCat(id) {

    $('#' + id).toggleClass('checked');
    $('#checkedcat_' + id).parent().parent().parent().remove();

}
